import {
  registerGlobalPlugins,
  type ModuleFederationRuntimePlugin,
} from '@module-federation/runtime';

// module-federation's SnapshotHandler.getManifestJson fetches mf-manifest.json
// (see resolveRemoteEntryUrl in ../config) via
// `loaderHook.lifecycle.fetch.emit(manifestUrl, {})`, falling back to a plain
// `fetch(manifestUrl, {})` with no cache override when no plugin claims the
// hook. That leaves the manifest fully subject to browser/CDN HTTP caching,
// so a redeployed remote can serve a stale manifest indefinitely. Registering
// this global `fetch` hook forces revalidation (a conditional request, not a
// full re-download) on every manifest/resource fetch made through the
// module-federation runtime, covering every remote resolved via
// resolveRemoteEntryUrl with a single registration.
const noCacheManifestFetchPlugin: ModuleFederationRuntimePlugin = {
  name: 'no-cache-manifest-fetch',
  fetch: (url, options) => fetch(url, { ...options, cache: 'no-cache' }),
};

export function initModuleFederationCacheBypass(): void {
  registerGlobalPlugins([noCacheManifestFetchPlugin]);
}
